import { Box } from '@mui/material';

/** Figma 8736:25529 — create_room 1 */
export const PASS_HEADER_WIDTH = 400;
export const PASS_HEADER_HEIGHT = 253;
export const PASS_HEADER_COLOR = '#003341';
export const PASS_HEADER_INSET_SHADOW = 'inset 0 12px 10px rgba(43, 0, 118, 0.39)';

export default function PassCardHeader({
  bgcolor = PASS_HEADER_COLOR,
  background,
  sx,
  ...props
}) {
  const fill = background || bgcolor;

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        overflow: 'hidden',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        ...sx,
      }}
      {...props}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          background: fill,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          borderRadius: 'inherit',
          boxShadow: PASS_HEADER_INSET_SHADOW,
        }}
      />
    </Box>
  );
}
